import React from "react";
import { Radio, Form } from "@tinper/next-ui";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

export type ButtonGroupProps = Record<string, any>;

const ButtonGroup: any = (props: any) => {
  const { separated = false } = props;
  const ref = React.useRef(null);
  return (
    <>
      <Form.Item
        name={props.name}
        size={props.size}
        style={{
          marginBottom: 0,
          lineHeight: 0,
          ...props.style
        }}
        className={separated ? "separated-radio-group" : ""}
      >
        <RadioGroup className={`as-dataform-buttongroup-${props.name || ""}`}>
          <div ref={ref} className="as-dataform-buttongroup">
            {props.options.map((item: any) => {
              // eslint-disable-next-line react/jsx-key
              return <RadioButton value={item.value}>{item.label}</RadioButton>;
            })}
          </div>
        </RadioGroup>
      </Form.Item>
    </>
  );
};
export default ButtonGroup;
